const getValue = (key) =>{
  try {
    if (sessionStorage.getItem(key)) {
      return JSON.parse(sessionStorage?.getItem(key));
    } else {
      return [];
    }    
  } catch (error) {
    return []
  }
}
const getObjectValue = (key) => {
  try {
    if (sessionStorage.getItem(key)) {
      const arr = JSON.parse(sessionStorage.getItem(key));
      return arr
    } else {
      return [];
    }
  } catch (error) {
    return []
  }
}
export default () => ({
  reasons: getValue('reasons'),
  partner: getValue('partner'),
  answers: getObjectValue('answers'),
  metrics: {
    uuid: getCookie('metricsUUID')
  },
  auth: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: null, // Ya no se guarda; sesión por cookies
    tokenExpiresIn: localStorage.getItem('token_expires_in') || null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null
  },
  /** Respuesta de GET clinical-notes/crypto/status (solo psicólogo) */
  clinicalNotesCryptoStatus: null,
  /** master_key en memoria (sesión actual); puede persistir en localStorage */
  clinicalNotesMasterKeyBytes: null,
  /** Psicólogo cerró el modal de desbloqueo sin obtener la master key (solo esta sesión SPA). */
  clinicalNotesUnlockDismissed: false,
  isFamilyRoute: false
});

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}